//
//
//
//
//
//

// import Table from "@/components/FilterTable/Table";

export default {
  name: "StoresTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {},
  data: () => ({
    separator: "horizontal",
    pagination: {
      rowsPerPage: 0
    },
    columns: [
      {
        name: "code",
        align: "left",
        label: "Código",
        field: "code",
        sortable: true
      },
      {
        name: "name",
        required: true,
        label: "Nome",
        align: "left",
        field: "name",
        sortable: true
      }
    ]
  })
};
